import { Button, Chevron, PageHeader, Tabs } from '@lmc/ui-kit'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import TodayMonitoring from './TodayMonitoring/TodayMonitoring'

const Monitoring = () => {
  const { t } = useTranslation()

  const flags = useFeatureFlags({
    flagNames: ['rostering_parked_features']
  })?.data

  const flagsRosteringParkedFeaturesEnabled =
    flags?.rostering_parked_features?.enabled

  const [activeTab, setActiveTab] = useState('1')

  const handleTabs = (tab: string) => setActiveTab(tab)

  return (
    <Container>
      <PageHeader title={t('MONITORING')}>
        <Link to={`/reports/rostering/rota-overview`}>
          <Button variant="text">
            {t('ROSTERING_REPORTS')}
            <Chevron direction="right" />
          </Button>
        </Link>
      </PageHeader>
      <Tabs
        onChange={handleTabs}
        activeKey={activeTab}
        tabBarStyle={tabBarStyle}
        items={[
          {
            key: '1',
            label: t('TODAY'),
            children: <TodayMonitoring />
          },
          ...(flagsRosteringParkedFeaturesEnabled
            ? [
                {
                  key: '2',
                  label: t('UPCOMING')
                }
              ]
            : [])
        ]}
      />
    </Container>
  )
}

const Container = styled.div`
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`
const tabBarStyle = { paddingLeft: 24 }

export default Monitoring
